import { render, staticRenderFns } from "./viewdetailMoney.vue?vue&type=template&id=ecb8b2b4&scoped=true&"
import script from "./viewdetailMoney.vue?vue&type=script&lang=js&"
export * from "./viewdetailMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb8b2b4",
  null
  
)

export default component.exports